import { MenuItem, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"

export function CriticalityMenuItem({ item }) {
    const { currentValue, onSelect } = useBoundContext()

    return (
        <MenuItem selected={item.value === currentValue} onClick={handleClick}>
            <Stack direction="row" spacing={1} alignItems="center">
                <Iconify icon={item.icon} sx={{ fontSize: 14, color: item.color }} />
                <Typography variant="body2">{item.label}</Typography>
            </Stack>
        </MenuItem>
    )

    function handleClick() {
        onSelect(item.value)
    }
}
